/**
 * RequiresAuth may be placed in front of a page to enforce authenticated access.
 * If an un-authenticated user attempts to access the page, they are instead redirected
 * to `/login`.
 *
 * All query params provided will remain intact, and an `app_return_path` will be appended
 * to the query so the auth pages know where to send the user afterwards.
 */
export default async function({ redirect, query, route, app }) {
  if (process.server) return

  const auth = await app.$getAuthInstance()

  await auth.currentAuthenticatedUser().catch(e => {
    let path = '/login'

    // We're in the checkout flow, which is likely a new user.  Sign them up!
    if (route.name.indexOf('checkout') >= 0) {
      path = '/register'
    }

    redirect({
      path,
      query: { ...query, app_return_path: route.path },
    })
  })
}
